import styles from './CardExpandable.module.css';
import {
  type BaseComponentPropsWithChildren,
  getBaseHTMLProps,
} from '../../../types';
import { cn } from '../../../utils';
import {
  type AccordionConfig,
  AccordionContextProvider,
  useAccordion,
} from '../../helpers/AccordionBase';

export type CardExpandableProps = BaseComponentPropsWithChildren<
  HTMLDivElement,
  Pick<AccordionConfig, 'isExpanded' | 'isInitiallyExpanded' | 'onChange'>
>;

export const CardExpandable = ({
  isInitiallyExpanded = false,
  isExpanded,
  onChange,
  id,
  children,
  className,
  style,
  htmlProps,
  ...rest
}: CardExpandableProps) => {
  const {
    id: accordionId,
    isExpanded: expanded,
    toggleExpanded,
    bodyContentRef,
    headerProps,
    bodyProps,
  } = useAccordion({ isInitiallyExpanded, isExpanded, onChange, id });

  return (
    <div
      {...getBaseHTMLProps(
        accordionId,
        cn(className, styles['container']),
        style,
        htmlProps,
        rest,
      )}
    >
      <AccordionContextProvider
        headerProps={headerProps}
        bodyProps={bodyProps}
        isExpanded={expanded}
        toggleExpanded={toggleExpanded}
        bodyContentRef={bodyContentRef}
      >
        {children}
      </AccordionContextProvider>
    </div>
  );
};

CardExpandable.displayName = 'CardExpandable';
